// extracted by mini-css-extract-plugin
export default {"fourth":"Sixth_fourth__wiDLc"};